import "./notebook.css";
import { resize } from "./utils/resize";
import NotebookMain from "./NotebookMain/NotebookMain";
import addIcon from "./icons/plus.png";
import locationIcon from "./icons/location.png";
import usersIcon from "./icons/users.png";
import categoriesIcon from "./icons/categories.png";
import sortIcon from "./icons/sort.png";
import calendarIcon from "./icons/calendar.png";
import starIcon from "./icons/star.png";
import searchIcon from "./icons/search.png";
import sendIcon from "./icons/plane.png";
import closeIcon from "./icons/close.png";
import { useEffect, useRef, useState } from "react";
import { compareAsc, compareDesc } from "date-fns";
import Calendar from "./Calendar/Calendar";
import axios from "axios";

import AddingModal from "./AddingModal/AddingModal";
import CategoriesModal from "./CategoriesModal/CategoriesModal";
import { useGlobalContext } from "../../../Context/Context";

const Notebook = () => {
  const {
    setItems,
    items,
    baseUrl,
    apiKey,
    loggedUser,
    locations,
    setLocations,
    users,
    setUsers,
  } = useGlobalContext();
  const [notebookItems, setNotebookItems] = useState(items);
  const [searchOpened, setSearchOpened] = useState(false);
  const [sortActive, setSortActive] = useState(false);
  const [bookmarkActive, setBookmarkActive] = useState(false);
  const [calendarOpened, setCalendarOpened] = useState(false);
  const [addingChecked, setAddingChecked] = useState(false);
  const [usersModalOpened, setUsersModalOpened] = useState(false);
  const [locationsModalOpened, setLocationsModalOpened] = useState(false);
  const [categoriesOpened, setCategoriesOpened] = useState(false);
  const [windowResized, setWindowResized] = useState(false);
  const [newUsers, setNewUsers] = useState([]);
  const [newLocations, setNewLocations] = useState([]);
  const [newCategories, setNewCategories] = useState([]);

  const notebookRef = useRef();

  /*window.addEventListener("resize", () =>
    resize(window.innerWidth, window.innerHeight, setWindowResized)
  );

  window.addEventListener("load", () =>
    resize(window.innerWidth, window.innerHeight, setWindowResized)
  );*/

  const handleSearch = () => {
    const term = notebookRef.current.querySelector(".search-input").value;
    const newItems = items.filter((item) => item.text.includes(term));
    setNotebookItems(newItems);
    openSearch();
  };

  const openSearch = () => {
    setSearchOpened(true);
  };

  const closeSearch = () => {
    setSearchOpened(false);
    setNotebookItems(items);
  };

  const handleSort = () => {
    const newItems = notebookItems.sort((a, b) =>
      sortActive ? compareAsc(a.date, b.date) : compareDesc(a.date, b.date)
    );
    setSortActive(!sortActive);
    setNotebookItems(newItems);
  };

  const handleBookmarked = () => {
    if (bookmarkActive) setNotebookItems(items);
    else {
      const newItems = items.filter((item) => item.isBookmarked);
      setNotebookItems(newItems);
    }
    setBookmarkActive(!bookmarkActive);
  };

  const handleCalendar = () => {
    setCalendarOpened(!calendarOpened);
  };

  const resetStates = () => {
    setNewLocations([]);
    setNewUsers([]);
  };

  const handleAdding = () => {
    setAddingChecked(!addingChecked);
    if (addingChecked) resetStates();
  };

  const handleAdd = () => {
    const text = notebookRef.current.querySelector(".search-input").value;
    if (text === "") return;
    const newNotebookItem = {
      id: notebookItems.length + 1,
      text,
      date: new Date(),
      users: newUsers,
      locations: newLocations,
      categories: newCategories,
      isBookmarked: false,
    };
    setNotebookItems([...notebookItems, newNotebookItem]);
    setItems([...notebookItems, newNotebookItem]);
    resetStates();
    setAddingChecked(false);
  };

  const handleUsersOpened = () => {
    setLocationsModalOpened(false);
    setCategoriesOpened(false);
    setUsersModalOpened(!usersModalOpened);
  };

  const handleLocationsOpened = () => {
    setUsersModalOpened(false);
    setCategoriesOpened(false);
    setLocationsModalOpened(!locationsModalOpened);
  };
  const handleCategoriesOpened = () => {
    setUsersModalOpened(false);
    setCategoriesOpened(!categoriesOpened);
    setLocationsModalOpened(false);
  };

  useEffect(() => {
    const handleFetchData = async () => {
      /*try {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/companies/readParentCompanies.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
          }
        );
        if (data.status === 200) {
        }
      } catch (e) {
        console.log(e);
        if (e.status === 404) {
        }
      }*/
      try {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/notebook/getLocationsInternal.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
          }
        );
        if (data.status === 200) {
          setLocations(data.data);
        }
      } catch (e) {
        console.log(e);
        if (e.status === 404) {
        }
      }
      try {
        const { data } = await axios.post(
          `${baseUrl}/admin_panel/notebook/getAllUsersInternal.php`,
          {
            user_id: loggedUser.id,
            api_key: apiKey,
          }
        );
        if (data.status === 200) {
          setUsers(data.data);
        }
      } catch (e) {
        console.log(e);
        if (e.status === 404) {
        }
      }
    };
    handleFetchData();
  }, []);

  return (
    <>
      <div className="notebook" ref={notebookRef}>
        <div className="notebook-icons">
          {searchOpened ? (
            <div className="notebook-icon" onClick={closeSearch}>
              <img src={closeIcon} alt="" />
            </div>
          ) : (
            <div className="notebook-icon" onClick={handleAdding}>
              <img src={addIcon} alt="" />
            </div>
          )}
          <div className={"notebook-icon"} onClick={handleLocationsOpened}>
            <img src={locationIcon} alt="" />
          </div>
          <div className={"notebook-icon"} onClick={handleUsersOpened}>
            <img src={usersIcon} alt="" />
          </div>
          <div className={"notebook-icon"} onClick={handleCategoriesOpened}>
            <img src={categoriesIcon} alt="" />
          </div>
        </div>
        {calendarOpened ? (
          <Calendar notebookItems={notebookItems} />
        ) : (
          <NotebookMain
            notebookItems={notebookItems}
            searchOpened={searchOpened}
            setNotebookItems={setNotebookItems}
            openSearch={openSearch}
            addingChecked={addingChecked}
            windowResized={windowResized}
          />
        )}
        <div className="notebook-icons">
          {searchOpened || addingChecked ? (
            <div
              className="notebook-icon"
              onClick={searchOpened ? handleSearch : handleAdd}
            >
              <img src={sendIcon} alt="" />
            </div>
          ) : (
            <div className="notebook-icon" onClick={openSearch}>
              <img src={searchIcon} alt="" />
            </div>
          )}
          <div
            className={
              addingChecked ? "notebook-icon disabled" : "notebook-icon"
            }
            onClick={handleSort}
          >
            <img src={sortIcon} alt="" />
          </div>
          <div
            className={
              addingChecked ? "notebook-icon disabled" : "notebook-icon"
            }
            onClick={handleCalendar}
          >
            <img src={calendarIcon} alt="" />
          </div>
          <div
            className={
              addingChecked ? "notebook-icon disabled" : "notebook-icon"
            }
            onClick={handleBookmarked}
          >
            <img src={starIcon} alt="" />
          </div>
        </div>
        {(usersModalOpened || locationsModalOpened) && (
          <AddingModal
            newItems={usersModalOpened ? newUsers : newLocations}
            isUsers={usersModalOpened}
            setNewItems={usersModalOpened ? setNewUsers : setNewLocations}
            setModalOpened={
              usersModalOpened ? setUsersModalOpened : setLocationsModalOpened
            }
          />
        )}
        {categoriesOpened && (
          <CategoriesModal
            notebookRef={notebookRef}
            newCategories={newCategories}
            setNewCategories={setNewCategories}
          />
        )}
      </div>
    </>
  );
};

export default Notebook;
